import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';


@Injectable()
export class BPProfilesBankDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public savePaypalDetails(bpProfileId:number, clientId:string, secret:string):Promise<void> {
    return this.httpDataService.doPOST(
      `rest/paypal/account/${bpProfileId}`,
      undefined,
      {
        clientId,
        secret
      },
      'Connecting…',
      'Error connecting with Paypal'
    );
  }
}